import { Dialog } from '@base-ui/react';
import { GlobeIcon } from 'lucide-react';
import { createContext, useState, type ReactNode } from 'react';

import Logo from '@/components/Logo/Logo.tsx';
import { queryClient } from '@/queryClient.ts';

import { getRegisterSourceData } from './analytics/registerSource.ts';
import { flagsQuery } from './flags.ts';

// oxlint-disable-next-line react/only-export-components
export const InAppGateContext = createContext<{
  /** Will show "open in browser" instructions if conditions are met. */
  isInAppBrowser: () => Promise<boolean>;
}>(undefined!);

export const InAppGateProvider: React.FC<{ children?: ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const isInAppBrowser = async (): Promise<boolean> => {
    const r = getRegisterSourceData();
    if (r.is_in_app_browser) {
      const flags = await queryClient.query(flagsQuery());
      if (flags.tiktokInAppGateKValues.includes(r.params.k)) {
        setIsOpen(true);
        return true;
      }
    }
    return false;
  };

  return (
    <InAppGateContext.Provider value={{ isInAppBrowser }}>
      <Dialog.Root open={isOpen}>
        <Dialog.Portal>
          <Dialog.Popup className="fixed inset-0 z-50">
            <InAppGateContent />
          </Dialog.Popup>
        </Dialog.Portal>
      </Dialog.Root>
      {children}
    </InAppGateContext.Provider>
  );
};

export const InAppGateContent = () => (
  <div className="flex size-full flex-col items-center bg-v1-primary-100 px-4 typography-v1-display text-white opacity-100 transition-opacity outline-none starting:opacity-0">
    <Logo className="my-6" />
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="43"
      height="70"
      fill="none"
      viewBox="0 0 43 70"
      className="-mt-12 mb-4 ml-auto"
    >
      <path
        fill="#fdc564"
        d="M.48 67.4a1.5 1.5 0 0 0 2.04 2.2L1.5 68.5zM32.56.44a1.5 1.5 0 0 0-2.12 0l-9.55 9.55a1.5 1.5 0 1 0 2.12 2.12l8.49-8.49 8.49 8.49a1.5 1.5 0 1 0 2.12-2.12zM1.5 68.5l1.02 1.1C12.69 60.18 33 33.44 33 1.5h-3C30 32.29 10.31 58.29.48 67.4z"
      />
    </svg>
    <h1 className="mb-6 typography-v1-h2">Åpne i nettleseren</h1>
    <GlobeIcon className="mb-6 size-19" strokeWidth={1.5} />
    <p className="text-center typography-v1-body2">
      For å logge inn med <b>BankID</b> må du fortsette i nettleseren din.
      <br />
      <br />
      Trykk på <b>•••</b> øverst til høyre og velg «Åpne i nettleser»
    </p>
  </div>
);
